<template>
  <div
    class="user-categories container"
    data-test="page-categories">
    <h4 class="t-c m-b font-normal"> What are you interested in?</h4>
    <p class="t-c m-b-3 sub-header">Tap a few topics and we’ll use that info to show you podcasts you’ll love </p>

    <loader
      v-show="!data_loaded"
      label="Loading Categories..."/>

    <h5
      v-if="data_loaded && !categories.length"
      class="font-normal t-c">No categories found</h5>

    <el-row
      type="flex"
      justify="center"
      class="d-flex-wrap content-area">

      <el-button
        v-for="(category, index) in categories"
        :key="index"
        :class="[{'selected': category.selected}]"
        :disabled="category.loading"
        type="plain"
        class="category-btn m-b"
        data-test="list-categories"
        @click="onSelectionToggle(category, !category.selected)">
        {{ category.name }}
      </el-button>
    </el-row>
    <div class="t-c m-t-3 action-buttons">
      <el-button
        class="btn-transparent large"
        type="plain"
        data-test="btn-skip"
        @click="skip">Skip</el-button>
      <el-button
        :disabled="!selectedCategories || !selectedCategories.length"
        type="primary"
        class="large"
        data-test="btn-next"
        @click="next">Next</el-button>
    </div>
    <!-- <div class="t-c m-t-3 mobile-action-panel hidden-sm-and-up">
      <el-button class="btn-transparent" type="plain" @click="skip">Skip</el-button>
      <el-button type="primary" @click="next" :disabled="!selectedCategories || !selectedCategories.length">Next</el-button>
    </div> -->
    <premium-upsell-modal
      :show_modal="showUpsellModal"
      @close="closePremiumUpsellModal"
    />
  </div>
</template>
<script>
import Loader from '../../components/Loader';
import PremiumUpsellModal from '../../components/PremiumUpsellModal';
import Podcast from '../../services/Podcast';
import User from '../../services/User';
import PageMixin from '../../shared/pageMixin';

export default {
  name: 'UserCategories',
  components: {
    loader: Loader,
    'premium-upsell-modal': PremiumUpsellModal,
  },
  mixins: [PageMixin],
  data() {
    return {
      pageName: 'Onboarding Topics',
      categories: [],
      data_loaded: false,
      category_service: new Podcast(),
      userProvider: new User(),
      selectedCategories: [],
      showUpsellModal: false,
    };
  },
  computed: {
    isSubscribed() {
      return this.$store.getters.user.is_subscribed;
    },
    user() {
      const { user } = this.$store.getters;

      return user;
    },
  },
  beforeMount() {
    // if (!this.$store.getters.creating_account.signup_completed) {
    //   this.$router.push('/listen');
    // }
  },
  mounted() {
    this.loadCategories();
    window.eventBus.$emit('onboarding-step-change', 2);
    if (!this.isSubscribed) {
      this.openPremiumUpsellModal();
    }
    // let page = document.getElementsByClassName('user-categories')[0]
    // let element = document.getElementsByClassName('content-area')[0]
    // let actionPanel = document.getElementsByClassName('mobile-action-panel')[0]
    // element.addEventListener('scroll', () => {
    //   if (element.scrollHeight - element.scrollTop === element.clientHeight)
    //   {
    //     actionPanel.classList.add('remove_fix')
    //   }
    //   else if ((element.scrollTop < element.scrollHeight - 2 * element.scrollTop) &&
    //   page.scrollTop < page.scrollHeight - page.scrollTop) {
    //     actionPanel.classList.remove('remove_fix')
    //   }
    //   else if (page.scrollTop < page.scrollHeight - page.scrollTop) {
    //     actionPanel.classList.remove('remove_fix')
    //   }
    //   else if (page.scrollHeight - page.scrollTop === page.clientHeight) {
    //     actionPanel.classList.add('remove_fix')
    //   }
    // })
  },
  methods: {
    loadCategories() {
      this.data_loaded = false;
      this.category_service.loadOnboardingTopics().then((resp) => {
        this.categories = resp;
        this.data_loaded = true;
        this.loadUserCategories();
      }).catch(() => {
        this.data_loaded = true;
      });
    },
    loadUserCategories() {
      this.userProvider.loadUserTopics().then((_resp) => {
        let resp = _resp;
        if (resp) {
          resp = resp || [];
          resp = resp.map(item => item.onboarding_topic);
          this.selectedCategories = resp.map(item => ({
            code: item.code,
            description: item.description,
          }));
          this.updateSelectedCategories();
        }
      }).catch(() => {
        this.data_loaded = true;
      });
    },
    onSelectionToggle(category, isSelected) {
      const categoryIndex = this.categories.findIndex(item => category.id === item.id);
      if (categoryIndex > -1) {
        this.categories[categoryIndex].selected = isSelected;
        this.$set(this.categories, categoryIndex, this.categories[categoryIndex]);

        const isAdded = this.selectedCategories.find(item => category.code === item.code);
        if (isAdded) {
          this.selectedCategories = this.selectedCategories.filter(item => item.code !== category.code);
        } else {
          this.selectedCategories.push({ code: category.code, description: category.description });
        }
      }
      // console.log('asd')
      // let isAdded = this.selectedCategories.find( item => { return category.id === item.category_uuid })

      // if (isAdded && !category.isSelected) {
      //   this.removeUserCategory(category, false)
      // }
      // else if (!isAdded && category.isSelected) {
      //   this.addUserCategory(category, true)
      // }
    },
    addUserCategory(_category) {
      let category = _category;
      this.userProvider.addUserTopic(category).then((resp) => {
        if (resp && resp.success) {
          category = {
            uuid: resp.uuid,
            category_uuid: category.id,
          };
          this.afterSuccess(category, true);
        }
      }).catch((error) => {
        this.showErrorMsg(error.response ? error.response.data.error : error);
        this.afterSuccess(_category, false);
      });
    },
    removeUserCategory(category) {
      const data = this.selectedCategories.find(item => item.category_uuid === category.id);
      if (!data) { return; }
      this.userProvider.removeUserCategory(data.uuid).then((resp) => {
        if (resp && resp.success) {
          this.afterSuccess(category, false);
        }
      })
        .catch((error) => {
          this.showErrorMsg(error.response ? error.response.data.error : error);
          this.afterSuccess(category, true);
        });
    },
    afterSuccess(category, isSelected) {
      if (isSelected) {
        this.selectedCategories.push(category);
      } else {
        this.selectedCategories = this.selectedCategories.filter(item => category.id !== item.category_uuid);
      }
      this.updateSelectedCategories();
    },
    updateSelectedCategories() {
      this.categories.forEach((_category) => {
        const category = _category;
        category.selected = !!this.selectedCategories.find(cat => cat.code === category.code);
        // return category
      });
    },
    next() {
      this.$store.commit('setCategoriesSelected', true);
      this.userProvider.saveOnboardingTopics(this.selectedCategories).then((resp) => {
        if (resp && resp.success) {
          const user = { ...this.user };
          user.registration_state = 'complete';
          this.$store.commit('setUser', user);
          if (this.user && this.user.is_subscribed) {
            this.$router.push({ path: '/listen', query: { newSubscription: true } });
          } else {
            this.$router.push('/listen');
          }
        } else {
          this.showErrorMsg('Unfortunately, an error occurred. Please try again.');
        }
      });
    },
    skip() {
      this.$store.commit('setCategoriesSelected', true);
      this.$router.push('/complete');

      if (this.user && this.user.is_subscribed) {
        this.$router.push({ path: '/listen', query: { newSubscription: true } });
      } else {
        this.$router.push('/listen');
      }
    },
    openPremiumUpsellModal() {
      this.showUpsellModal = true;
    },
    closePremiumUpsellModal() {
      this.showUpsellModal = false;
    },
  },
};
</script>
<style lang="scss">
@import "../../assets/scss/variables.scss";
.user-categories {
  position: relative;
  overflow-y: auto;
  h4 {
    margin-top: 64px;
  }
  .content-area {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    overflow-y: auto;
  }

  .category-btn {
    color: $black;
    border-color: $black;
    padding: 11px 20px;

    &:focus, &:visited {
      background: #ffffff;
      color: $black;
      border-color: $black;
    }
    &:hover, &.is-disabled {
      background-color: #f7f7f7;
      border-color: $black;
      color: $black;
    }
    &:active{
      background-color: #ffffff;
      color: $black;
      border-color: $black;
    }
    &.selected {
      background: $peach;
      color: $black;
    }
  }

  .mobile-action-panel {
    position: fixed;
    bottom: 0px;
    margin: 0 auto;
    padding: 16px 0;
    display: block;
    background: #fff;
    width: 100%;
    z-index: 9995;
  }
  .is-loading{
    background-color: #ffffff;
    color: $black;
    border-color: $black;
  }
  .remove_fix{
    position: relative;
  }
  .action-buttons {
    margin-top: 40px;
    padding-bottom: 40px;
  }
}

@media (max-width: 768px) {
  .user-categories {
    h4 {
      margin-top: 40px;
    }
  }
}

@media (max-width: 567px) {
  .user-categories {
    h4 {
      margin-top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/onboarding/Categories.vue